"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    statement: finley_types_1.FinStatementV2.StatementSchema,
    reportFrequency: finley_types_1.FinStatementV2.ReportFrequencySchema,
    currency: finley_types_1.Bank.CurrencyCodeSchema.optional().describe('Defaults to USD'),
    basis: finley_types_1.FinStatementV2.StatementBasisSchema.optional().describe('Defaults to actual'),
    multiplier: v4_1.z.number().optional().describe('Defaults to 1'),
    csvArtifactSlug: v4_1.z
        .string()
        .describe('csv containing the financial statement information'),
    rawArtifactSlug: v4_1.z.string().optional().describe('raw source file'),
    markupArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('highlighted pdf file, generated during an ai2Csv transform'),
});
exports.nodeType = 'file_finStatement';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'finStatement';
//# sourceMappingURL=types.js.map